export default __webpack_public_path__ + "static/media/rules-agreement-background-mobile.a04c11e0.png";